import { Row, Table, Col, Card } from "antd";
import React, { useEffect, useState } from "react";
import DynamicTable from "../pages/DynamicTable";
import Left from "../assets/images/Left.png";
import Print from "../assets/images/Print.png";
import Download from "../assets/images/Download.png";
import Doubleauro from "../assets/images/Doubleauro.png";
import * as glanceawareApi from "../services/api/glanceaware";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";

const columns = [
  {
    title: "FaceAware Id",
    dataIndex: "FaceAwareId",
  },
  {
    title: "There Loss Of Memory",
    dataIndex: "IsThereLossOfMemory",
    render: (IsThereLossOfMemory) => (IsThereLossOfMemory ? "True" : "False"),
  },
  {
    title: "True Names",
    dataIndex: "TrueNames",
  },
  {
    title: "True Profession",
    dataIndex: "TrueProfession",
  },
  {
    title: "Selected Names",
    dataIndex: "SelectedNames",
  },
  {
    title: "Selected Profession",
    dataIndex: "SelectedProfession",
  },
  {
    title: "Session Id",
    dataIndex: "SessionId",
  },
  {
    title: "UserId",
    dataIndex: "UserId",
  },
];

const GlanceAware = () => {
  const [glanceawareTable, setGlanceawareTable] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getGlanceawareData();
  }, []);

  const getGlanceawareData = async () => {
    try {
      setLoading(true);
      const {
        data: { data },
      } = await glanceawareApi?.getGlanceAware();
      setGlanceawareTable(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleExport = () => {
    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.json_to_sheet(glanceawareTable);

    XLSX.utils.book_append_sheet(wb, ws, "glanceAware");
    XLSX.writeFile(wb, "glanceAware.xlsx");
  };
  return (
    <>
      <div className="Container">
        <Row className="Maincontainer">
          <Col span={8}>
            <div className="Leftside-col">
              <Link to={"/dashboard"}>
                <img src={Left}></img>
              </Link>
              <h2>Data collected on GlanceAware tests</h2>
            </div>
            <br></br>
          </Col>
        </Row>
        <div className="Audioaware">
          <Col span={8}>
            <div className="Rightside-col Audioaware">
              <button>
                {" "}
                <img src={Doubleauro}></img>
                Sort by
              </button>
            </div>
          </Col>

          <Col span={8}>
            <div className="center-col">
              <img src={Print}></img>
              <h4>Print</h4>

              <Col span={8}>
                <div className="Download-col" onClick={handleExport}>
                  <img src={Download}></img>
                  <h4>Download</h4>
                </div>
              </Col>
            </div>
          </Col>
        </div>

        <DynamicTable
          columns={columns}
          dataSource={glanceawareTable}
          loading={loading}
        />
      </div>
    </>
  );
};
export default GlanceAware;
